module.exports = __webpack_public_path__ + "static/media/joint.ae286369.svg";